export default {
  policyRenewal: 'تجديد الوثيقة',
  policyDetails: 'تفاصيل الوثيقة',
  policyRenewalAlertTitle: 'الوثيقة سينتهي تاريخها قريباً',
  policyRenewalAlertDescription: 'يرجى مراجعة بياناتك والمتابعة للتجديد',
  policyAndProfessionInfoDetails: 'الوثيقة و التخصص الطبي',
  declarationsDetails: 'تصريحات مالك الوثيقة',
  hintQuestion: 'ما المطلوب لتجديد الوثيقة؟',
  hintAnswerTitle1: 'معلومات الوثيقة والمهنة',
  hintAnswerDescription1:
    'إذا كانت هناك أي تحديثات على وثيقتك أو مهنتك، يرجى تقديم التفاصيل للتجديد.',
  hintAnswerTitle2: 'تفاصيل الإقرار',
  hintAnswerDescription2:
    'إذا كانت هناك أي تحديثات على إقرارك، يرجى تقديم التفاصيل للتجديد.',
  previousPolicyNumber: 'رقم الوثيقة السابقة',
  previousInsuranceCompany: 'اسم شركة التأمين  السابقة',
  previousPolicyExpirationDate: 'تاريخ انتهاء الوثيقة السابقة',
  previousPolicyRetroactiveDate: 'تاريخ الأثر الرجعي',
  retroactiveDateRequired: 'تاريخ الأثر الرجعي مطلوب',
  daysRemaining: '{{days}} يوم/أيام متبقية',
  proceedToRenewal: 'المتابعة للتجديد',
  confirmRenewal: 'تأكيد واستمرار',
  policyRenewalPopupTitle:
    'أهلاً بك {{policyHolderName}} مجدداً في تأميني، وثيقتك مستحقة للتجديد بتاريخ {{expiryDate}}',
  policyRenewalPopupDescription: 'يرجى مراجعة وتأكيد بياناتك أدناه للتجديد',
  expiryDate: 'تاريخ الانتهاء',
  policyholderDetails: 'بيانات مالك الوثيقة',
  policyholderId: 'رقم الهوية أو الإقامة',
} as const
